/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Stage_DeliveryInputs */

const en_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero-Downtime Delivery`)
};

const ar_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم بلا توقف`)
};

const bn_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জিরো-ডাউনটাইম ডেলিভারি`)
};

const de_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung ohne Ausfallzeiten`)
};

const es_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega sin tiempo de inactividad`)
};

const fr_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison sans temps d'arrêt`)
};

const pt_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega com tempo de inatividade zero`)
};

const zh_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`零停机交付`)
};

const tr_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıfır Kesinti Süresiyle Teslimat`)
};

const ru_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка без простоев`)
};

const pl_svc_stage_delivery = /** @type {(inputs: Svc_Stage_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostawa bez przestojów`)
};

/**
* | output |
* | --- |
* | "Zero-Downtime Delivery" |
*
* @param {Svc_Stage_DeliveryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_stage_delivery = /** @type {((inputs?: Svc_Stage_DeliveryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Stage_DeliveryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_stage_delivery(inputs)
	if (locale === "bn") return bn_svc_stage_delivery(inputs)
	if (locale === "de") return de_svc_stage_delivery(inputs)
	if (locale === "es") return es_svc_stage_delivery(inputs)
	if (locale === "fr") return fr_svc_stage_delivery(inputs)
	if (locale === "pt") return pt_svc_stage_delivery(inputs)
	if (locale === "zh") return zh_svc_stage_delivery(inputs)
	if (locale === "tr") return tr_svc_stage_delivery(inputs)
	if (locale === "ru") return ru_svc_stage_delivery(inputs)
	if (locale === "pl") return pl_svc_stage_delivery(inputs)
	return en_svc_stage_delivery(inputs)
});